import { Dispatch } from "redux";
import axios from "../../utils/axios.tsx";
import { searchFieldActions } from "../../store/search/searchField.tsx";
import { loginAsAnonymousUser } from "../../store/auth.tsx";
import { conversationActions } from "../../store/conversation.tsx";
import { RootState } from "../../store/types.tsx";

interface AskQuestionParams {
  dispatch: Dispatch;
  getState: () => RootState;
  isAuthenticated?: boolean;
  searchText: string;
  stopAnimation: () => void;
}

export async function ask({
  dispatch,
  getState,
  searchText,
  stopAnimation,
}: AskQuestionParams): Promise<void> {
  const url = "/v1/anonymous/ask/";

  try {
    dispatch(searchFieldActions.setAwaitingAskResponse(true));
    const selectedConversation =
      getState().conversationState.selectedConversation;
    dispatch(
      conversationActions.appendExchange({
        prompt: searchText,
        response: null,
        conversation_id: selectedConversation || "new",
      }),
    );

    const response = await axios.post(
      url,
      JSON.stringify({ text: searchText }),
      { withCredentials: true },
    );

    dispatch(loginAsAnonymousUser());

    dispatch(conversationActions.appendExchange(response.data));
    dispatch(
      conversationActions.setSelectedConversation(
        response.data.conversation_id,
      ),
    );
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    stopAnimation();
    dispatch(searchFieldActions.setAwaitingAskResponse(false));
  }
}

export default ask;
